import { Controller } from '@hotwired/stimulus'
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {

  connect() {
    this.element[this.identifier] = this

    this.noteId = this.data.get("id")
  }

  onEditClick(e) {
    const url = e.currentTarget.dataset.editFormUrl
    const request = new FetchRequest('get', url, { responseKind: 'turbo-stream' })
    request.perform()
  }

  onDeleteClick(e) {
    e.preventDefault()
    e.stopPropagation()

    if (window.confirm(e.target.dataset.confirmText)) {
      const request = new FetchRequest(e.target.dataset.method, e.target.dataset.url, { responseKind: 'turbo-stream' })
      request.perform()
    }
  }

}
